import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';


class AbacusCheckbox extends React.Component {

  constructor (props)
  {
    super (props);
    this.state = {
      checked: props.checked,
    };
  }

  handleChange = name => event => {
    if(this.props.onChange !== undefined){
      this.props.onChange(event);
    }
  };
  
    render() {
      return (
        <FormControlLabel
          control={
            <Checkbox
                checked={this.props.checked}
                onChange={this.handleChange('checked')}
                value="checked"
                color="primary"
                disabled={this.props.disabled}
            />
          }
          label={this.props.label}
        />
        
      );
    }
  }

  export default AbacusCheckbox;